import { DragIcon } from '@fourthwall/icons'
import React, { useState } from 'react'
import { SortableHandle } from 'react-sortable-hoc'

import { Icon } from '../../Icon'
import { TableOptionsCell } from '../TableOptionsCell'
import * as S from './styled'
import type { TableRowProps } from './types'

const DragHandle = SortableHandle(() => (
  <S.DragHandle data-testid="TableRow.DragHandle">
    <Icon component={DragIcon} height={16} />
  </S.DragHandle>
))

export const TableRow = ({
  component,
  row,
  actions,
  to,
  href,
  target,
  sortable,
  isDragging,
  highlighted,
  children,
  renderFooter,
  onClick,
}: TableRowProps) => {
  const [isHover, setIsHover] = useState(false)
  const [dropdownKey, setDropdownKey] = useState(0)

  return (
    <S.Wrapper
      $hoverable={!!(to || href || onClick)}
      $highlighted={highlighted}
      $sortable={!!sortable}
      $isDragging={!!isDragging}
    >
      <div>
        <S.Row
          as={component || 'div'}
          to={to}
          href={href}
          target={target}
          role="row"
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => {
            setIsHover(false)
            setDropdownKey((key) => key + 1)
          }}
          data-testid="TableRow"
        >
          {sortable && (
            <S.DragHandleContainer>
              <DragHandle />
            </S.DragHandleContainer>
          )}

          <S.ChildrenContainer>
            <S.Children onClick={onClick}>{children}</S.Children>
            {renderFooter && <S.Footer>{renderFooter(row, { isHover })}</S.Footer>}
          </S.ChildrenContainer>
          {actions && (
            <S.Options>
              <TableOptionsCell dropdownKey={dropdownKey} actions={actions} row={row} />
            </S.Options>
          )}
        </S.Row>
      </div>
    </S.Wrapper>
  )
}
